import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "relative flex flex-col xl:flex-row items-stretch xl:items-center justify-between gap-6 rounded-3xl bg-gradient-to-r from-[#edf4ff] via-white to-white border border-slate-100 p-6 md:p-8 text-left shadow-sm" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row items-center sm:items-start xl:items-center gap-6 flex-1 min-w-0" }
const _hoisted_3 = { class: "shrink-0 flex items-center justify-center" }
const _hoisted_4 = { class: "space-y-3 flex-1 min-w-0 text-center sm:text-left" }
const _hoisted_5 = { class: "text-2xl md:text-3xl font-black text-slate-800 tracking-tight" }
const _hoisted_6 = { class: "text-sm md:text-base text-slate-500 font-semibold leading-relaxed mt-1" }
const _hoisted_7 = { class: "text-[#1f7aff] font-black" }
const _hoisted_8 = { class: "flex flex-wrap items-center justify-center sm:justify-start gap-2.5 pt-1" }
const _hoisted_9 = { class: "inline-flex items-center gap-1.5 pl-1 sm:pl-2" }
const _hoisted_10 = { class: "text-xs font-bold text-slate-400 flex items-center gap-1" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "w-full xl:w-72 border-t xl:border-t-0 xl:border-l border-slate-100 pt-5 xl:pt-0 xl:pl-6 space-y-2 shrink-0" }
const _hoisted_13 = { class: "flex items-baseline gap-2" }
const _hoisted_14 = { class: "text-3xl font-black text-slate-800" }
const _hoisted_15 = {
  key: 0,
  class: "text-xs font-semibold text-slate-500"
}
const _hoisted_16 = { class: "h-2.5 w-full bg-slate-100 rounded-full overflow-hidden" }
const _hoisted_17 = { class: "text-[11px] font-semibold text-slate-400 pt-0.5" }

import { computed } from "vue";
import { DotLottieVue } from "@lottiefiles/dotlottie-vue";
import { Button } from "@/components/ui/button";
import DMSuiteIcon from "@/components/iconify/DMSuiteIcon.vue";
import { DASHBOARD_ICONS } from "@/config/dashboardIcons";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientWelcomeBanner',
  props: {
    companyName: { default: "" },
    needsReviewCount: { default: 0 },
    completedTasksCount: { default: 0 },
    totalTasksCount: { default: 0 },
    overallProgress: { default: undefined },
    selectedPeriod: { default: "this_month" }
  },
  emits: ["update:period", "new-request", "contact-support", "review-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const clientName = computed(() => {
  return props.companyName || "Valued Client";
});

const progressPercent = computed(() => {
  if (props.overallProgress !== undefined && props.overallProgress !== null) {
    return Math.round(props.overallProgress);
  }
  if (props.totalTasksCount > 0) {
    return Math.round((props.completedTasksCount / props.totalTasksCount) * 100);
  }
  return 0;
});

const periodLabel = computed(() => {
  switch (props.selectedPeriod) {
    case "last_month":
      return "last month";
    case "last_90_days":
      return "in the last 90 days";
    case "all_time":
      return "all-time";
    case "this_month":
    default:
      return "this month";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(DotLottieVue), {
          style: {"height":"120px","width":"150px","transform":"rotate(-10deg)"},
          autoplay: "",
          loop: "",
          src: "https://lottie.host/22d0ec44-e355-4465-8e4a-297dc4928739/gKTrWTYDRE.json"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", _hoisted_5, " Welcome back, " + _toDisplayString(clientName.value) + "! ", 1),
          _createElementVNode("p", _hoisted_6, [
            _cache[4] || (_cache[4] = _createTextVNode(" Your marketing is moving forward. You have ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "text-[#1f7aff] font-black underline decoration-2 decoration-[#1f7aff]/30 hover:text-[#185adb] transition-colors",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('review-click')))
            }, _toDisplayString(__props.needsReviewCount) + " " + _toDisplayString(__props.needsReviewCount === 1 ? 'item' : 'items'), 1),
            _cache[5] || (_cache[5] = _createTextVNode(" that need your review and ", -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.completedTasksCount) + " deliverables", 1),
            _createTextVNode(" completed " + _toDisplayString(periodLabel.value) + ". ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(Button), {
            size: "sm",
            class: "bg-[#1f7aff] hover:bg-[#185adb] text-white font-bold rounded-xl h-9 px-4 text-xs shadow-xs flex items-center gap-1.5 transition-all",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('new-request')))
          }, {
            default: _withCtx(() => [
              _createVNode(DMSuiteIcon, {
                icon: _unref(DASHBOARD_ICONS).plus,
                size: 15
              }, null, 8, ["icon"]),
              _cache[6] || (_cache[6] = _createTextVNode(" New Request ", -1))
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            size: "sm",
            variant: "outline",
            class: "border-slate-200 bg-white hover:bg-slate-50 text-slate-700 font-bold rounded-xl h-9 px-4 text-xs shadow-xs flex items-center gap-1.5 transition-all",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('contact-support')))
          }, {
            default: _withCtx(() => [
              _createVNode(DMSuiteIcon, {
                icon: _unref(DASHBOARD_ICONS).socialMedia,
                size: 15,
                "custom-class": "text-[#1f7aff]"
              }, null, 8, ["icon"]),
              _cache[7] || (_cache[7] = _createTextVNode(" Contact Support ", -1))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _createVNode(DMSuiteIcon, {
                icon: _unref(DASHBOARD_ICONS).calendar,
                size: 15,
                "custom-class": "text-slate-400"
              }, null, 8, ["icon"]),
              _cache[8] || (_cache[8] = _createTextVNode(" Period: ", -1))
            ]),
            _createElementVNode("select", {
              value: __props.selectedPeriod,
              class: "h-9 rounded-xl border border-slate-200 bg-white px-2.5 py-1 text-xs font-bold text-slate-700 focus:outline-none focus:ring-2 focus:ring-[#1f7aff]/20 shadow-xs cursor-pointer",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:period', ($event.target as HTMLSelectElement).value)))
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("option", { value: "this_month" }, "This Month", -1),
              _createElementVNode("option", { value: "last_month" }, "Last Month", -1),
              _createElementVNode("option", { value: "last_90_days" }, "Last 90 Days", -1),
              _createElementVNode("option", { value: "all_time" }, "All Time", -1)
            ]))], 40, _hoisted_11)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex items-center justify-between text-xs font-bold text-slate-400 uppercase tracking-wider" }, [
        _createElementVNode("span", null, "Overall Completion"),
        _createElementVNode("span", { class: "text-[11px] font-semibold text-slate-400 lowercase" }, "all-time scope")
      ], -1)),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", _hoisted_14, _toDisplayString(progressPercent.value) + "%", 1),
        (__props.totalTasksCount > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, " (" + _toDisplayString(__props.completedTasksCount) + " / " + _toDisplayString(__props.totalTasksCount) + " tasks) ", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", {
          class: "h-full bg-blue-600 rounded-full transition-all duration-500",
          style: _normalizeStyle({ width: `${progressPercent.value}%` })
        }, null, 4)
      ]),
      _createElementVNode("p", _hoisted_17, _toDisplayString(__props.totalTasksCount > 0 ? `${__props.completedTasksCount} of ${__props.totalTasksCount} total tasks completed` : 'No active tasks scheduled'), 1)
    ])
  ]))
}
}

})